"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Separator } from "@/components/ui/separator";
import { resourceNavigation } from "@/components/resource-navigation";
import {
  Sidebar,
  SidebarHeader,
  SidebarContent,
  SidebarGroup,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  useSidebar,
} from "@/components/ui/sidebar";
import { useDocsAccountPending } from "@/providers/account-session";
import { DocsAccountPrompt } from "./account-prompt";

function DocsRail({
  items,
  bottom = false,
}: {
  items: typeof resourceNavigation;
  bottom?: boolean;
}) {
  const pathname = usePathname();
  const { isMobile, setOpenMobile } = useSidebar();
  return (
    <SidebarGroup className={bottom ? "mt-auto" : undefined}>
      <SidebarMenu className="items-center gap-1">
        {items.map((item) => (
          <SidebarMenuItem key={item.title}>
            <SidebarMenuButton
              asChild
              data-rail-key={item.title}
              variant="custom"
              tooltip={{ children: item.title, hidden: false }}
              isActive={
                pathname === item.url || pathname.startsWith(`${item.url}/`)
              }
              className="flex size-8 !w-8 items-center !justify-center !gap-0"
            >
              <Link
                href={item.url}
                aria-label={item.title}
                onClick={() => {
                  if (isMobile) setOpenMobile(false);
                }}
              >
                <item.icon className="!size-5" />
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  );
}

export function DocsGuestRail() {
  const pending = useDocsAccountPending();
  return (
    <Sidebar
      collapsible="none"
      className="w-12 shrink-0 border-r md:!w-[calc(var(--sidebar-width-icon)_+_1px)]"
    >
      <SidebarHeader data-rail-key="organization" className="pb-2">
        <DocsAccountPrompt kind="organization" pending={pending} />
      </SidebarHeader>
      <SidebarContent className="lb-scrollbar-overlay">
        <Separator data-rail-key="separator" className="mx-auto w-8" />
        <DocsRail items={resourceNavigation} />
        <DocsRail bottom items={[]} />
      </SidebarContent>
    </Sidebar>
  );
}
